import { ProductionIncident } from '../../types';
import ControlListSection from '../../shared/ControlListSection';
import { getIncidentTableCells } from 'domain/projects/newProject/engineering/List/getIncidentTableCells';

const ProductionIncidentsSection = ({
  title,
  incidents,
  emptyMessage,
}: {
  title: string;
  incidents: ProductionIncident[];
  emptyMessage: string;
}) => {
  return (
    <ControlListSection
      title={title}
      items={incidents}
      listSource="incidents"
      emptyMessage={emptyMessage}
      getTableCells={() => Promise.resolve(getIncidentTableCells({ createdAtSize: 3, notesFieldSize: 2 }))}
    />
  );
};

export default ProductionIncidentsSection;
